import styled from '@emotion/styled';
import tw from 'twin.macro';
import { Link } from 'gatsby';
import { secondaryStyles } from '@/components/Link/Link.styles';

export const Tag = styled(Link)`
  ${secondaryStyles}
  ${tw`font-inter font-semi-bold `}
  ${tw`text-tag-s`}
  ${tw`py-[7px] px-[14px]`}
  ${tw`bg-ui-colours-ui3 border-2 hover:bg-neutrals-n1 active:bg-ui-colours-ui2`}
  ${tw`border-ui-colours-ui3 hover:border-ui-colours-ui3 active:border-ui-colours-ui2 active:text-neutrals-n1`}
`;
